/*
  Kiddos Kicks store enhancements (Oct 2026).
  Everything here lives in our own file so Dawn theme updates keep it.
  Loaded by sections/kk-global.liquid (in the header group). Each part is safe to run many times:
  it only changes the page when something is missing, so it re-applies itself after Dawn
  re-draws the product form, variant picker, cart drawer or cart icon.

  1. Add to Cart button: cart icon + price of the selected size/colour
  2. Variant picker: hide one-value options, tidy option names, sort sizes, small "Size guide" link
  3. Header cart icon
  4. Cart drawer: Spend & Save progress bar + "You're saving" line
  5. Wording: "Proceed to Checkout", "Total", "Pick a size", shipping note on product page, "Colour:" in cart lines
  6. Image alt text falls back to the product title
*/
(function () {
  if (window.__kkEnhance) return;
  window.__kkEnhance = true;

  var CART_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>';
  var RULER_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="2" y="7" width="20" height="10" rx="2"/><path d="M6 7v4M10 7v3M14 7v4M18 7v3"/></svg>';

  var TEXT = {
    checkout: 'Proceed to Checkout',
    total: 'Total',
    chooseOptions: 'Pick a size',
    sizeGuide: 'Size guide'
  };

  // Spend & Save tiers (cart total in cents -> dollars off)
  var TIERS = [
    { at: 8000, save: 10 },
    { at: 12000, save: 20 },
    { at: 16000, save: 35 }
  ];

  function money(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD';
    try {
      return new Intl.NumberFormat('en-AU', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function setText(el, text) {
    if (el && el.textContent.trim() !== text) el.textContent = text;
  }

  /* ---------- 1. Add to Cart: icon + price ---------- */
  function selectedVariant(root) {
    var el = (root || document).querySelector('[data-selected-variant]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function enhanceAddToCart() {
    var addLabel = (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';
    document.querySelectorAll('product-form .product-form__submit').forEach(function (btn) {
      var inner = btn.querySelector('span');
      if (!inner) return;
      if (btn.disabled) return; // sold out / unavailable keep Dawn's own wording
      var root = btn.closest('product-info') || document;
      var variant = selectedVariant(root);
      var priceText = variant && typeof variant.price === 'number' ? money(variant.price) : '';
      var hasIcon = inner.querySelector('.kk-atc-icon');
      if (hasIcon) {
        var p = inner.querySelector('.kk-atc-price');
        if (priceText && (!p || p.textContent !== priceText)) {
          if (!p) {
            p = document.createElement('span');
            p.className = 'kk-atc-price';
            inner.appendChild(p);
          }
          p.textContent = priceText;
        }
        return;
      }
      if (inner.textContent.trim() !== addLabel) return;
      inner.classList.add('kk-atc-inner');
      inner.innerHTML =
        '<span class="kk-atc-icon" aria-hidden="true">' + CART_SVG + '</span><span class="kk-atc-label"></span>' +
        (priceText ? '<span class="kk-atc-price"></span>' : '');
      inner.querySelector('.kk-atc-label').textContent = addLabel;
      if (priceText) inner.querySelector('.kk-atc-price').textContent = priceText;
    });
  }

  /* ---------- 2. Variant picker ---------- */
  function sizeOrder(value) {
    var v = String(value);
    if (v.indexOf('EU') > -1) v = v.split('EU').pop();
    v = v.replace(/[()]/g, '').trim().split('–')[0].split('-')[0].trim();
    var n = Math.round(parseFloat(v) * 10);
    return n > 0 ? n : null;
  }

  function cleanName(node) {
    // First text node of a legend/label: "Size (US - EU):" -> "Size (US - EU)"
    for (var i = 0; i < node.childNodes.length; i++) {
      var c = node.childNodes[i];
      if (c.nodeType === 3 && c.textContent.trim()) {
        var hasValue = node.querySelector('[data-selected-value]');
        var t = c.textContent.replace(/\s*:+\s*$/, '');
        if (hasValue) t = t + ': ';
        if (t !== c.textContent) c.textContent = t;
        return;
      }
    }
  }

  function enhanceVariantPicker() {
    var sizeFit = document.getElementById('kk-size-fit');
    document.querySelectorAll('variant-selects .product-form__input').forEach(function (box) {
      var isDropdown = box.classList.contains('product-form__input--dropdown');
      var count = isDropdown ? box.querySelectorAll('option').length : box.querySelectorAll('input[type="radio"]').length;
      if (count === 1 && !box.classList.contains('kk-single-option')) box.classList.add('kk-single-option');

      var label = isDropdown ? box.querySelector('label.form__label') : box.querySelector('legend');
      if (!label) return;
      var nameHolder = label.querySelector('.kk-option-name') || label;
      cleanName(nameHolder);

      var isSize = /size/i.test(label.textContent);
      if (!isSize) return;
      if (!box.classList.contains('kk-size-option')) box.classList.add('kk-size-option');

      // Sizes smallest to largest
      if (!isDropdown) {
        box.querySelectorAll('input[type="radio"]').forEach(function (input) {
          var lab = box.querySelector('label[for="' + input.id + '"]');
          var o = sizeOrder(input.value);
          if (lab && o && lab.style.order !== String(o)) lab.style.order = o;
        });
      }

      // Small "Size guide" link on the same line as the label
      if (!sizeFit || box.querySelector('.kk-size-guide-link')) return;
      var row = isDropdown ? label.parentElement : label;
      if (!isDropdown) {
        var nameSpan = document.createElement('span');
        nameSpan.className = 'kk-option-name';
        while (label.firstChild) nameSpan.appendChild(label.firstChild);
        label.appendChild(nameSpan);
      } else {
        var wrap = document.createElement('div');
        label.parentNode.insertBefore(wrap, label);
        wrap.appendChild(label);
        row = wrap;
      }
      row.classList.add('kk-size-legend');
      var a = document.createElement('a');
      a.href = '#kk-size-fit';
      a.className = 'kk-size-guide-link';
      a.innerHTML = RULER_SVG + '<span>' + TEXT.sizeGuide + '</span>';
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var d = document.getElementById('kk-size-fit');
        if (d) {
          d.open = true;
          d.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
      row.appendChild(a);
    });
  }

  /* ---------- 3. Header cart icon ---------- */
  function enhanceCartIcon() {
    var w = document.querySelector('#cart-icon-bubble .svg-wrapper');
    if (w && !w.classList.contains('kk-header-cart-icon')) {
      w.classList.add('kk-header-cart-icon');
      w.setAttribute('aria-hidden', 'true');
      w.innerHTML = CART_SVG;
    }
  }

  /* ---------- 4. Cart drawer Spend & Save ---------- */
  var cartTotal = null;
  var cartCount = 0;

  function fetchCart() {
    return fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (c) {
        cartTotal = c.total_price;
        cartCount = c.item_count;
        enhanceCartDrawer();
      })
      .catch(function () {});
  }

  function spendSaveHtml(total) {
    var achieved = 0;
    TIERS.forEach(function (t) {
      if (total >= t.at) achieved = t.save;
    });
    var next = null;
    for (var i = 0; i < TIERS.length; i++) {
      if (total < TIERS[i].at) {
        next = TIERS[i];
        break;
      }
    }
    var prev = 0;
    var segs = TIERS.map(function (t) {
      var span = t.at - prev;
      var pct = total <= prev ? 0 : Math.min(100, Math.floor(((total - prev) * 100) / span));
      prev = t.at;
      return '<div class="kk-css-seg"><div class="kk-css-seg__fill" style="width:' + pct + '%;"></div></div>';
    }).join('');
    var stages = TIERS.map(function (t) {
      var done = total >= t.at;
      return (
        '<div class="kk-css-stage' + (done ? ' is-done' : '') + '"><span class="kk-css-stage__dot">' + (done ? '✓' : '') +
        '</span><span class="kk-css-stage__label">SAVE $' + t.save + '</span></div>'
      );
    }).join('');
    var msg;
    if (!next) {
      msg = "🎉 You've unlocked the max <strong>$" + TIERS[TIERS.length - 1].save + ' off</strong> — nice!';
    } else {
      var remaining = Math.ceil((next.at - total) / 100) * 100;
      if (achieved > 0) {
        msg =
          '✅ Saving <strong>$' + achieved + '</strong> so far — add <strong>' + money(remaining) +
          '</strong> more to unlock an <u>extra $' + (next.save - achieved) + '</u> off ($' + next.save + ' total!)';
      } else {
        msg = '🎯 Add <strong>' + money(remaining) + '</strong> more to unlock <strong>$' + next.save + ' off</strong> your order!';
      }
    }
    return {
      achieved: achieved,
      html: '<div class="kk-css-stages">' + stages + '</div><div class="kk-css-track">' + segs + '</div><p class="kk-css-msg">' + msg + '</p>'
    };
  }

  function enhanceCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || cartTotal === null) return;
    var header = drawer.querySelector('.drawer__inner .drawer__header');
    var bar = drawer.querySelector('.kk-cart-spend-save');
    var saving = drawer.querySelector('.kk-total-savings');
    var sig = String(cartTotal);

    if (!cartCount || drawer.classList.contains('is-empty') || !header) {
      if (bar) bar.remove();
      if (saving) saving.remove();
      return;
    }
    var data = spendSaveHtml(cartTotal);
    if (!bar || bar.getAttribute('data-total') !== sig) {
      if (bar) bar.remove();
      bar = document.createElement('div');
      bar.className = 'kk-cart-spend-save';
      bar.setAttribute('data-total', sig);
      bar.innerHTML = data.html;
      header.insertAdjacentElement('afterend', bar);
    }
    var totals = drawer.querySelector('.drawer__footer .totals');
    if (data.achieved > 0 && totals) {
      if (!saving || saving.getAttribute('data-total') !== sig) {
        if (saving) saving.remove();
        saving = document.createElement('p');
        saving.className = 'kk-total-savings';
        saving.setAttribute('data-total', sig);
        saving.innerHTML = "🎉 You're saving <strong>$" + data.achieved + '</strong> on this order';
        totals.parentNode.insertBefore(saving, totals);
      }
    } else if (saving) {
      saving.remove();
    }
  }

  /* ---------- 5. Wording ---------- */
  function enhanceWording() {
    document.querySelectorAll('#CartDrawer-Checkout, #checkout').forEach(function (b) {
      setText(b, TEXT.checkout);
    });
    document.querySelectorAll('.totals__total').forEach(function (h) {
      setText(h, TEXT.total);
    });
    document.querySelectorAll('.quick-add__submit').forEach(function (b) {
      for (var i = 0; i < b.childNodes.length; i++) {
        var c = b.childNodes[i];
        if (c.nodeType === 3 && /choose options/i.test(c.textContent)) c.textContent = ' ' + TEXT.chooseOptions + ' ';
      }
    });
    // Cart lines: option names already end in ":" so Dawn shows "Colour:: Purple"
    document.querySelectorAll('.product-option dt').forEach(function (dt) {
      var t = dt.textContent;
      var n = t.replace(/\s*:\s*:\s*$/, ':');
      if (n !== t) dt.textContent = n;
    });
    // Product page: keep "Taxes included." but drop the "Shipping calculated at checkout" line
    document.querySelectorAll('.product__tax').forEach(function (el) {
      var link = el.querySelector('a');
      if (!link && !/calculated at checkout/i.test(el.textContent)) return;
      if (link) link.remove();
      el.childNodes.forEach(function (c) {
        if (c.nodeType === 3) c.textContent = c.textContent.replace(/\s*calculated at checkout\.?/i, '');
      });
    });
  }

  /* ---------- 6. Image alt text ---------- */
  function enhanceAltText() {
    var title = document.querySelector('.product__title h1');
    if (title) {
      document.querySelectorAll('.product__media img[alt=""], .product__media-item img[alt=""], .thumbnail img[alt=""]').forEach(function (img) {
        img.alt = title.textContent.trim();
      });
    }
    document.querySelectorAll('.card-wrapper').forEach(function (card) {
      var h = card.querySelector('.card__heading');
      if (!h) return;
      card.querySelectorAll('img[alt=""]').forEach(function (img) {
        img.alt = h.textContent.trim();
      });
    });
  }

  /* ---------- run + re-run after Dawn re-draws ---------- */
  function runAll() {
    try { enhanceVariantPicker(); } catch (e) {}
    try { enhanceAddToCart(); } catch (e) {}
    try { enhanceCartIcon(); } catch (e) {}
    try { enhanceCartDrawer(); } catch (e) {}
    try { enhanceWording(); } catch (e) {}
    try { enhanceAltText(); } catch (e) {}
  }

  var queued = false;
  var runs = 0;
  var windowStart = Date.now();
  function schedule() {
    if (queued) return;
    // Safety cap: never more than 60 passes a second, so it can't slow the page down
    var now = Date.now();
    if (now - windowStart > 1000) {
      windowStart = now;
      runs = 0;
    }
    if (++runs > 60) {
      queued = true;
      setTimeout(function () {
        queued = false;
        runs = 0;
        windowStart = Date.now();
        runAll();
      }, 1000);
      return;
    }
    queued = true;
    // A microtask (not requestAnimationFrame), so it still runs in background tabs
    Promise.resolve().then(function () {
      queued = false;
      runAll();
    });
  }

  var drawerRefetch = null;
  function start() {
    runAll();
    fetchCart();
    new MutationObserver(function (mutations) {
      var drawerChanged = false;
      for (var i = 0; i < mutations.length; i++) {
        var t = mutations[i].target;
        if (t.closest && t.closest('.kk-cart-spend-save, .kk-total-savings')) continue;
        if (t.closest && t.closest('cart-drawer')) drawerChanged = true;
      }
      schedule();
      if (drawerChanged) {
        clearTimeout(drawerRefetch);
        drawerRefetch = setTimeout(fetchCart, 120);
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });

    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        fetchCart();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
